// Angular
import { Component, ViewChild, OnInit, ElementRef, HostListener } from '@angular/core';
// Models
import { Post } from '../../models/post';
// External
import { AngularFireDatabase, FirebaseListObservable } from 'angularfire2/database';
import * as lodash from 'lodash';
import { Attachment } from '../../models/attachment';
import { FirebaseApp } from 'angularfire2';
import * as moment from 'moment';
import { Subject } from 'rxjs/Subject'
import { DatePipe } from '@angular/common';

@Component({
  selector : 'app-posts-pending',
  templateUrl: './posts.component.html'
})
export class PendingPostsComponent implements OnInit {
  @ViewChild('textarea') textarea: ElementRef;
  private attachment: Attachment;
  private attachmentExt: string;
  monthMap: any
  monthArray: any[] = [];
  public posts: Array<Post>;
  public nextKey: any;
  public prevKeys: Array<any>;
  public text: string;
  private offsetPosts: number;
  public filterargs: Post;
  public months = [{ monthName: 'January', monthNo: 0 },
  { monthName: 'February', monthNo: 1 },
  { monthName: 'March', monthNo: 2 },
  { monthName: 'April', monthNo: 3 },
  { monthName: 'May', monthNo: 4 },
  { monthName: 'June', monthNo: 5 },
  { monthName: 'July', monthNo: 6 },
  { monthName: 'August', monthNo: 7 },
  { monthName: 'September', monthNo: 8 },
  { monthName: 'October', monthNo: 9 },
  { monthName: 'November', monthNo: 10 },
  { monthName: 'December', monthNo: 11 }]
  public items: any;
  public shared: Post;
  public mentioned: Array<any>;
  public commentList: Array<any>;
  public likeList: Array<{ author: string; authorImage: string; key: string }>;
  public shareLikes: Array<{ author: string; authorImage: string; key: string }>;
  public shareComments: Array<any>;
  public postData: any;
  private shortPosts: Array<{ $value: string; $key: string; }>;
  public query: string;
  public imageLoader = true;
  public likeCount: number;
  public commentCount: number;
  public mentionCount: number;
  public search = {
    monthNo: 0,
    year: 2018
  }
  private typingDelay: any;
  public users: Array<any>;
  public selectedUsers: Array<any>;
  public activeIndex: number;
  public date: any;
  public deleteIndex: number;
  constructor(private fireDatabase: AngularFireDatabase, private datePipe: DatePipe, private firebase: FirebaseApp) {
    this.prevKeys = [];
    this.offsetPosts = 20;
    this.query = '';
    this.filterargs = new Post();
    this.users = [];
    this.selectedUsers = [];
    this.activeIndex = -1;
    this.deleteIndex = -1;
    var currentYear = new Date().getFullYear();
    var diff = currentYear - 2017;
    this.monthMap = []

    console.log(this.search);

    for (var i = 0; i <= diff; i++) {

      this.monthMap.push({
        name: (2017 + i), items: [{ monthName: 'January', monthNo: 0, posts: [] },
        { monthName: 'February', monthNo: 1, posts: [] },
        { monthName: 'March', monthNo: 2, posts: [] },
        { monthName: 'April', monthNo: 3, posts: [] },
        { monthName: 'May', monthNo: 4, posts: [] },
        { monthName: 'June', monthNo: 5, posts: [] },
        { monthName: 'July', monthNo: 6, posts: [] },
        { monthName: 'August', monthNo: 7, posts: [] },
        { monthName: 'September', monthNo: 8, posts: [] },
        { monthName: 'October', monthNo: 9, posts: [] },
        { monthName: 'November', monthNo: 10, posts: [] },
        { monthName: 'December', monthNo: 11, posts: [] }]
      })

    }
    this.search = {
      monthNo: new Date().getMonth(),
      year: new Date().getFullYear()
    }


  }
  ngOnInit() {
    this.getPosts();

  }

  public dateChange(event) {
    this.filterargs.date = this.datePipe.transform(event, 'yyyy-MM-dd')

  }
  getPosts(startKey?: any) {
    const fireList = this.fireDatabase.list(`/index/posts`
      // , {
      //     query: {
      //         orderByKey: true,
      //         startAt: startKey,
      //         limitToFirst: this.offsetPosts + 1
      //     }
      // }
    ).subscribe(result => {
      // this.shortPosts = lodash.slice(result, 0, this.offsetPosts);
      // this.nextKey = lodash.get(result[this.offsetPosts], '$key');
      const i = result.length;
      this.shortPosts = result;
      this.initPostsList();
      fireList.unsubscribe();
    }, error => {
      console.error(error);
    });
  }

  goNext() {
    this.prevKeys.push(lodash.first(this.shortPosts)['$key']);
    this.getPosts(this.nextKey);
  }

  goPrev() {
    const prevKey = lodash.last(this.prevKeys);
    this.prevKeys = lodash.dropRight(this.prevKeys);
    this.getPosts(prevKey);
  }

  initPostsList() {
    if (this.shortPosts && !this.shortPosts.length) {
      return;
    }
    var convertTimeStampToMonth = (timestamp) => {
      const date = new Date(timestamp * 1000);
      const monthNumber = date.getMonth();
      return monthNumber;
    }
    var convertTimeStampToYear = (timestamp) => {
      const date = new Date(timestamp * 1000);
      const monthNumber = date.getFullYear();
      return monthNumber;
    }
    this.posts = [];

    let count = 0;
    lodash.forEach(this.shortPosts, item => {

      const fireObject = this.fireDatabase.object(`/users-posts/${item.$value}/${item.$key}`)
        .subscribe(result => {
          if (result.text && result.postStatus && (+result.postStatus == 1 || +result.postStatus == 3 )) {
            result.author = result.author

            const date = new Date(result.date * 1000);

            const myMonth = convertTimeStampToMonth(result.date);
            const diff = convertTimeStampToYear(result.date) - 2017;

            this.monthMap[diff]["items"][myMonth].posts.push(result);
            const o = date.getFullYear() + '-' + ('0' + (date.getMonth() + 1)).slice(-2)
              + '-' + ('0' + date.getDate()).slice(-2);
            result.date = o;

            if (this.search.monthNo == myMonth && diff == (new Date().getFullYear() - 2017)) {
              this.posts.push(result);
              count++;             
            }

            if (count === 1) {
              this.postDetail(result)

            }
            this.imageLoader = false;


            if (fireObject) {
              fireObject.unsubscribe();
            }
          }

        });


    });
    // for (let prop in this.monthMap) {
    //     if (this.monthMap[prop].posts.length > 0) {
    //         this.monthArray.push(this.monthMap[prop]);
    //     }

    // }

  }
  public onYearChange(year) {
    console.log(year);
    this.search.year = year
    this.changePost()
  }
  public onMonthChange(month) {
    console.log(month);
    this.search.monthNo = month
    this.changePost()

  }
  public changePost() {
    var i = -1
    for (i = 0; i < this.monthMap.length; i++) {
      var element = this.monthMap[i];
      if (element.name == this.search.year) {
        break;
      }
    }
    if (i != this.monthMap.length && i > -1) {
      var l = -1
      for (l = 0; l < this.monthMap[i].items.length; l++) {
        var element = this.monthMap[i].items[l];
        if (element.monthNo == this.search.monthNo) {
          break;
        }
      }
      if (l != this.monthMap[i].items.length && l > -1) {
        this.posts = this.monthMap[i].items[l].posts
      }
    }
  }
  deletePost(post: Post) {
    const index = this.posts.indexOf(post);
    this.posts.splice(index, 1);
  }
  postDetail(post: Post) {
    $('html, body').animate({ scrollTop: '1px' });
    this.commentList = [];
    this.likeList = [];
    this.shareLikes = [];
    this.shareComments = []
    this.postData = post;
    if (post.photo) {
      this.attachmentExt = post.photo.url
    }
    this.text = this.postData.text;
    this.fireDatabase.object(`/users/${post.author}`)
      .subscribe((user: any) => {
        this.postData.authorName = user.username;
        this.postData.authorImage = user.avatar_thumb;
      });
    if (this.postData.mentioned) {
      this.mentioned = [];
      this.mentionCount = 0
      lodash.forEach(this.postData.mentioned, (mention, key) => {
        this.mentionCount++;
        this.mentioned.push({
          "user_name": mention.username,
          "user_id": key,
          "type": mention.type
        });
      });
    }
    if (this.postData.shared) {
      this.fireDatabase.object(`/users-posts/${this.postData.shared.uid}/${this.postData.shared.pid}`)
        .subscribe((shared) => {
          this.shared = shared;
          if (shared.$value) {
            this.postData.isShared = true;
            console.log(this.shared);
            this.fireDatabase.object(`/users/${shared.author}`)
              .subscribe((user: any) => {
                this.postData.Sharedauthor = user.username;
                this.postData.SharedauthorImage = user.avatar_thumb;
              });
            this.fireDatabase.object(`/posts/${this.shared.$key}/likes`)
              .subscribe((likes) => {
                if (likes) {
                  lodash.forEach(likes, (like) => {
                    this.fireDatabase.object(`/users/${like}`)
                      .subscribe((user: any) => {
                        like = user.username;
                        this.shareLikes.push({
                          'author': user.username,
                          'authorImage': user.avatar_thumb,
                          'key': user.$key
                        });
                      });
                  });
                }
              });
            this.fireDatabase.object(`/posts/${this.shared.$key}/comments`)
              .subscribe((comments) => {
                if (comments) {
                  lodash.forEach(comments, (comment) => {
                    if (comment) {
                      this.fireDatabase.object(`/users/${comment.author}`)
                        .subscribe((user: any) => {
                          comment.author = user.username;
                          comment.authorImage = user.avatar_thumb;
                          comment.key = user.$key
                          this.shareComments.push(comment);
                        });
                    }
                  });
                }
              });
          }
        });
    } else {
      this.postData.isShared = false;
    }
    this.fireDatabase.object(`/posts/${post.$key}/likes`)
      .subscribe((likes) => {
        this.likeCount = 0;
        if (likes) {
          lodash.forEach(likes, (item, like) => {
            this.likeCount++;
            if (item) {
              this.fireDatabase.object(`/users/${like}`)
                .subscribe((user: any) => {
                  like = user.username;
                  this.likeList.push({
                    'author': user.username,
                    'authorImage': user.avatar_thumb,
                    'key': user.$key
                  }
                  );
                });
            }
          });
        }
      });
    this.fireDatabase.object(`/posts/${post.$key}/comments`)
      .subscribe((comments) => {
        this.commentCount = 0;
        if (comments) {
          lodash.forEach(comments, (comment) => {
            this.commentCount++;
            if (comment) {
              this.fireDatabase.object(`/users/${comment.author}`)
                .subscribe((user: any) => {
                  comment.author = user.username;
                  comment.authorImage = user.avatar_thumb;
                  comment.key = user.$key
                  this.commentList.push(comment);
                  // this.postData.date = moment().unix();
                  lodash.forEach(this.commentList, (item) => {
                    item.date = new Date(item.date * 1000);
                    var dd = item.date.getDate();
                    var mm = item.date.getMonth() + 1;
                    var yyyy = item.date.getFullYear();
                    item.date = dd + '/' + mm + '/' + yyyy;
                  });
                });
            }
          });
        }
      });
  }
  findAuthor(author) {
    return author;
  }

  // --------------------------------------edit text of modal post text--------------------------------

  @HostListener('window:keydown', ['$event'])
  keyDown(event: KeyboardEvent) {
    if (event.keyCode === 37 || event.keyCode === 39) {
      this.query = '';
    }

    if (event.keyCode === 40) {
      event.preventDefault();

      if (this.activeIndex < this.users.length - 1) {
        this.activeIndex++;
      }
    }

    if (event.keyCode === 38) {
      event.preventDefault();

      if (this.activeIndex > 0) {
        this.activeIndex--;
      }
    }

    if (event.keyCode === 13) {
      if (this.activeIndex !== -1) {
        event.preventDefault();

        this.addUser(this.users[this.activeIndex]);
      }
    }
  }

  addUser(user) {
    const endMentionText = this.textarea.nativeElement.selectionStart;
    const startMentionText = endMentionText - (this.query.length + 1);
    const startText = this.text.slice(0, startMentionText);
    const endText = this.text.slice(endMentionText).replace(/^\s+/, '');
    const replaceText = `@${user.username}`;

    this.selectedUsers.push(user);
    this.text = `${startText}${replaceText} ${endText}`;
    this.activeIndex = -1;
    this.query = '';

    setTimeout(() => {
      this.textarea.nativeElement.selectionStart = startText.length + replaceText.length + 1;
      this.textarea.nativeElement.selectionEnd = startText.length + replaceText.length + 1;
    });

    this.checkMentioned();
    this.postData.text = this.text;

    this.updateMentioned()
  }

  checkMentioned() {
    if (!this.text) {
      return;
    }

    const mentioned = this.text.match(/(?:@)(\w+)/g);

    if (!mentioned || !mentioned.length) {
      return;
    }

    this.selectedUsers.forEach((user, index) => {
      const username = `@${user.username}`;
      if (mentioned.indexOf(username) < 0) {
        this.selectedUsers.splice(index, 1);
      }
    });
    console.log(this.selectedUsers)
  }

  searchMention(query: string) {
    this.query = query.replace('@', '');
    console.log(this.query.toLowerCase().trim());

    this.fireDatabase.list('/users', {
      query: {
        orderByChild: 'username',
        startAt: this.query.toLowerCase().trim(),
        limitToFirst: 5
      }
    })
      .subscribe((result: Array<any>) => {
        console.log(result)
        this.users = result;
      });
  }

  typing() {
    const regexMention = /(?:@)(\w+)/g;
    const cursorPosition = this.textarea.nativeElement.selectionStart;
    const value = this.text.slice(0, cursorPosition);
    const words = value.split(' ');

    this.query = '';

    if (words && words.length) {
      const lastWord = words[words.length - 1];

      if (lastWord.match(regexMention)) {
        clearTimeout(this.typingDelay);

        this.typingDelay = setTimeout(() => {
          this.searchMention(lastWord);
        }, 400);
      }
    }
    this.postData.text = this.text;

    this.updateMentioned()
    // this.checkMentioned();
    // this.onChange.emit({
    //     mentioned: this.selectedUsers,
    //     text: this.text
    // });
  }
  updateMentioned() {
    if (this.postData.mentioned) {

    } else {
      this.postData.mentioned = {}
    }
    if (this.selectedUsers.length > 0) {
      for (let i = 0; i < this.selectedUsers.length; i++) {
        const element = this.selectedUsers[i];
        this.postData.mentioned[element.$key] = {
          type: element.type,
          username: element.username
        }

      }
    }
    console.log(this.postData.mentioned)
  }
  // ----------------------------------------image -----------------------------------------
  public changeAttachment(attachment: Attachment): void {
    this.attachment = attachment;

    if (this.attachment) {
      this.attachmentExt = this.attachment.file.name.split('.').pop();
      // console.log(this.attachmentExt)
    } else {
      this.attachmentExt = '';
    }
  }


  private uploadFile(): Promise<any> {
    return new Promise((resolve, reject) => {
      if (this.attachment) {
        const filename = `${moment().unix()}.${this.attachmentExt}`;
        this.firebase.storage().ref(`/posts/${this.postData.author}`).child(filename)
          .put(this.attachment.file)
          .then(result => resolve(result))

          .catch(error => reject(error));
      } else {
        return resolve();
      }
    });
  }

  // --------------------------------------update----------------------------------------------------
  public submit(): void {
    let str = String(this.postData.text).match(/@[a-zA-Z0-9]{1,}/g)
    console.log(str)
    lodash.forEach(this.postData.mentioned, (item, key) => {
      if (str != null && str.length > 0) {
        var k = str.findIndex(x => x.replace("@", "") == item.username)
        console.log(item, k)
        if (k == -1) {
          delete this.postData.mentioned[key]
        }
      } else {
        delete this.postData.mentioned
      }
    })
    // this.postData.author = this.fireAuth.auth.currentUser.uid;
    this.postData.date = moment().unix();

    // this.postData.text =this.text;

    this.uploadFile()
      .then(fileResult => {
        if (fileResult && fileResult.downloadURL) {
          if (fileResult.metadata.contentType.match('image')) {
            this.postData.photo = {
              url: fileResult.downloadURL,
              width: this.attachment.width,
              height: this.attachment.height
            };
          }

          if (fileResult.metadata.contentType.match('video')) {
            this.postData.video = { url: fileResult.downloadURL };
          }
        }
        delete this.postData.authorName
        console.log(this.postData)
        this.fireDatabase.database.ref(`/users-posts/${this.postData.author}/${this.postData.$key}`)
          .set(this.postData)
          .then(postResult => {

            this.getPosts();
            $('#myModal').modal('hide');

          })
          .catch(error => {
            this.error(error);
          });
      })
      .catch(error => {
        this.error(error);
      });
  }
  private error(error): void {
    console.error(error);

    alert('Sorry, something went wrong!');


  }
  reset() {
    this.filterargs = new Post()
    this.date = ""

  }
  remove() {
    this.postData.photo = null

  }
}

